
import {
  Award,
  Clock,
  Shield,
  Sparkles,
  Star,
  ThumbsUp,
  Zap
} from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import '../../../../assets/css/subscreens/customer/aboutus/whychooseus/WhyChooseUs.css';


const FEATURES = [
  {
    icon: <Shield size={32} />,
    title: 'Verified Responders',
    description: 'Unlike ordinary platforms, every Responder goes through verification to ensure safe and reliable services.',
    color: '#0491e1'
  },
  {
    icon: <Star size={32} />,
    title: 'Trusted Quality',
    description: 'Choose from skilled professionals with ratings, reviews, and proven service experience.',
    color: '#f59e0b'
  },
  {
    icon: <Clock size={32} />,
    title: 'Faster Service Matching',
    description: 'Our platform helps you quickly find the right Responder for your needs without wasting time.',
    color: '#10b981'
  },
  {
    icon: <ThumbsUp size={32} />,
    title: 'Transparent Experience',
    description: 'Clear pricing, genuine reviews, and no hidden charges — everything stays simple and honest.',
    color: '#8b5cf6'
  },
  {
    icon: <Award size={32} />,
    title: 'Secure & Reliable',
    description: 'We focus on seekers trust by providing a safer way to hire and manage services.',
    color: '#ef4444'
  },
  {
    icon: <Zap size={32} />,
    title: 'Easy Booking Platform',
    description: 'Book, communicate, and track your service from one convenient platform.',
    color: '#0491e1'
  }
];



const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % FEATURES.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="wcu-section" ref={sectionRef}>
      
      {/* Background Elements */}
      <div className="wcu-bg-pattern" />
      <div className="wcu-bg-circle wcu-bg-circle--1" />
      <div className="wcu-bg-circle wcu-bg-circle--2" />
      <div className="wcu-bg-circle wcu-bg-circle--3" />

      <div className="wcu-container">

        {/* ═══ HEADER ═══ */}
        <div className={`wcu-header ${isVisible ? 'wcu-fade-in' : ''}`}>
         <div className="wcu-badge">
  <Sparkles size={16} />
  <span>WHY PICKS4TIPS?</span>
</div>
          
         <h2 className="wcu-title">
  What Makes Picks4Tips Different?
</h2>

<p className="wcu-subtitle">
  More than just a service platform — we connect you with trusted professionals through a secure, transparent, and reliable experience.
</p>
        </div>

        {/* ═══ FEATURES GRID ═══ */}
        <div className={`wcu-features ${isVisible ? 'wcu-stagger' : ''}`}>
          {FEATURES.map((feature, index) => (
            <div
              key={index}
              className= "wcu-feature-card "
              style={{ animationDelay: `${index * 0.1}s` }}
          
            >
              <div 
                className="wcu-feature-icon"
                style={{ 
                  background: `linear-gradient(135deg, ${feature.color}15 0%, ${feature.color}08 100%)`,
                  borderColor: `${feature.color}30`
                }}
              >
                <div style={{ color: feature.color }}>
                  {feature.icon}
                </div>
              </div>
              
              <h3 className="wcu-feature-title">{feature.title}</h3>
              <p className="wcu-feature-desc">{feature.description}</p>
              
              {/* <div className="wcu-feature-glow" style={{ background: feature.color }} /> */}
            </div>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default WhyChooseUs;